import { Fragment } from 'react'
import { TimelineController } from '../../../CommonComponents/timeline/Timeline'
import useUrlParams from '../../hooks/useUrlParams';
import useViewer from '../../hooks/useViewer';

const Controller = () => {
    const { dashboard } = useUrlParams();
    const { viewer, multiplier, set_multiplier, viewer_state, set_viewer_state } = useViewer()

    const onStepChange = (value: number) => {
        if (!viewer) return
        viewer.clock.multiplier = value
        set_multiplier(value)
        set_viewer_state('play')
    }
    const onControllerChange = (value: 'play' | 'pause') => {
        if (!viewer) return
        viewer.clock.multiplier = value === 'play' ? multiplier || 1 : 0
        set_multiplier(value === 'play' ? multiplier || 1 : multiplier)
        set_viewer_state(value)
    }

    if (dashboard !== 'summary') return null
    return (
        <Fragment>
            <TimelineController
                onStepChange={onStepChange}
                onControllerChange={onControllerChange}
                step={multiplier}
                controllerState={viewer_state}
                showController
            />
        </Fragment>
    )
}

export default Controller